export default __webpack_public_path__ + "7b36141fa0f19446014fc9f10a9d502d.svg";